// extracted by mini-css-extract-plugin
export default {"btn":"LoadMoreButton_btn__Ln-BR"};